import React from 'react';
import pt from 'prop-types';
import Icon from 'components/icon';
import StorefrontEditorPage from 'components/storefront/editor/sidebar/page';

import './sidebar.scss';

export default class StorefrontEditorPageGroup extends React.PureComponent {
  static propTypes = {
    noRecordsMessage: pt.string,
    pageGroup: pt.object.isRequired,
    selectedPage: pt.object,
    onClickPage: pt.func,
    onClickBack: pt.func,
  };

  renderBackButton() {
    const { pageGroup, onClickBack } = this.props;

    return (
      <button
        className="storefront-editor--page-group--back-button"
        type="button"
        onClick={onClickBack}
      >
        <Icon fa="chevron-left" width={20} /> {pageGroup.label}
      </button>
    );
  }

  renderPages() {
    const { noRecordsMessage, pageGroup, selectedPage, onClickPage } =
      this.props;
    const { items } = pageGroup;
    const hasItems = items?.length > 0;

    if (!hasItems) {
      return (
        <div className="storefront-editor--no-records">{noRecordsMessage}</div>
      );
    }

    return (
      <div className="storefront-editor--page-group--pages">
        {items.map((page) => (
          <StorefrontEditorPage
            key={page.id}
            page={page}
            selectedPage={selectedPage}
            onClickPage={onClickPage}
          />
        ))}
      </div>
    );
  }

  render() {
    return (
      <div className="storefront-editor--page-group">
        {this.renderBackButton()}
        {this.renderPages()}
      </div>
    );
  }
}
